import IndicatorsPool from "./IndicatorsPool"
import { observable, computed, decorate, toJS, autorun} from "mobx"
import { store } from "../stores/store"

class Badge {

  notif = false
  wasActive = false

  constructor(jsonBadge) {
    Object.assign(this, jsonBadge)
    if(this.threshold_min === null) this.threshold_min = -(Infinity)
    if(this.threshold_max === null) this.threshold_max = Infinity


    // la fonction passée en param se lance si isActive change
    // autorun(()=>{
    //   if(this.isActive && !this.wasActive) {
    //     this.notif = true
    //     this.wasActive = true
    //   }
    // })
  }

  get title1() { return store.t(this.id + "_title1", "") }
  get title2() { return store.t(this.id + "_title2", "") }
  get subtitle() { return store.t(this.id + "_subtitle", "")}
  get description() { return store.t(this.id + "_description", "???")}

  // ne renvoie que les badges qui viennent de s'activer
  check() {
    // console.log("check, ", this, this.wasActive)
    if(!this.indicator_id) return false
    if(this.wasActive) return false

    let indicatorValue = IndicatorsPool.getIndicatorValue(this.indicator_id)
    let valid_min = indicatorValue > this.threshold_min
    let valid_max = indicatorValue <= this.threshold_max
    let activated =  valid_min && valid_max
    if(activated) {
      this.notif = true
      this.wasActive = true
    }


    return activated
  }



}

decorate(Badge, {
  wasActive: observable,
  notif: observable
})


class BadgesPool {
  all = []
  unlockedDuringThisGame = []

  init(badges) {
    this.unlockedDuringThisGame = []
    this.all = badges
    .map(b => new Badge(b))
    .filter(b => b.id !== null)
  }

  get(id) {
    return this.all.find(b => b.id === id)
  }



  applySavedValues(data) {

    data.forEach(savedBadge => {
      let badge = this.get(savedBadge.id)
      if(badge) {
        badge.wasActive = savedBadge.wasActive
      }
    })
  }

  recalculate() {
    this.all.forEach(b => {
      let justUnlocked = b.check()
      if(justUnlocked) this.unlockedDuringThisGame.push(b.id)
    })

    // console.log("unlockedDuringThisGame", this.unlockedDuringThisGame)
  }

  reset() {
    this.all.forEach(b => {
      if(this.unlockedDuringThisGame.includes(b.id)) {
        b.wasActive = false
        b.notif = false
      }
    })

    this.unlockedDuringThisGame = []


  }
  get sorted() {



    let sorted = [...this.all].sort((a, b) => {
      // les isActive en 1er
      if(a.wasActive && !b.wasActive) return -1
      if(b.wasActive && !a.wasActive) return 1
      return 0
      // les notif en 1er
    })

    sorted = sorted.sort((a, b) => {
      // les notif en 1er
      if(a.notif && !b.notif) return -1
      if(b.notif && !a.notif) return 1
      return 0
    })

    return sorted
  }

  get notif() {
    return this.all.some(b => b.notif)
  }

  unNotify() {
    this.all.forEach(b => b.notif = false)
  }

}


decorate(BadgesPool, {
  notif: computed,
  sorted: computed
})



export default new BadgesPool()